/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import { useSporforyaContext } from '../../context';
import useCache from '../../hooks/useCache';
import { AUTHENTICATION_TOKEN_KEY } from '../../utils/auth';
import useForgotPassword from './useForgotPassword';
import { toast } from 'react-toastify';

const ForgotPassword = () => {
  const { token } = useSporforyaContext();
  const navigate = useNavigate();
  const emailRef = useRef('');
  const passwordRef = useRef('');
  const { forgotPassword, response, isLoading, error } = useForgotPassword();

  const onSubmitHandle = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    forgotPassword(emailRef.current);
    (response?.status === 200 || response?.status === 201) &&
      toast.success(response?.message);
  };

  const onEmailChange = (value: string) => {
    emailRef.current = value;
  };

  return (
    <div className="flex w-full h-full">
      <div className="hidden w-[50%] h-[100vh] bg-[url('./assets/login-bg.jpeg')] bg-cover bg-center min-[920px]:block" />
      <div className="w-full h-full flex flex-col justify-center items-center min-[920px]:w-[50%]">
        <div className="block absolute w-full h-full bg-[url('./assets/login-without-bg.png')] bg-cover bg-center -z-10 blur-[2px] min-[920px]:hidden" />
        <form
          className="w-[360px] h-56 flex flex-col justify-between"
          onSubmit={onSubmitHandle}>
          <h1 className="text-5xl text-white min-[920px]:text-black">
            Forgot Password
          </h1>
          <Input
            required
            className="max-[920px]:border-transparent"
            type="email"
            placeholder="Email Address"
            onInput={onEmailChange}
          />
          <Button type="submit" text="Submit" showLoader={isLoading} />
          <span
            className={`text-xs text-center text-red-500 font-bold ${
              !error && 'opacity-0'
            }`}>
            Your username is wrong, please try again
          </span>
          <span
            className={`text-sm text-center text-primary-main font-bold ${
              !response && 'opacity-0'
            }`}>
            {response?.message}
          </span>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
